"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnualHomeCountChangePopUpWidget = void 0;
var React = require("react");
var journey_model_1 = require("@athena-portal/journey-model");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var journey_services_1 = require("@athena-portal/journey-services");
var reactstrap_1 = require("reactstrap");
var core_1 = require("@athena-portal/core");
var commonFunctions_1 = require("../../../../commonFunctions");
var AnnualHomeCountChangePopUpWidget = exports.AnnualHomeCountChangePopUpWidget = /** @class */ (function (_super) {
    __extends(AnnualHomeCountChangePopUpWidget, _super);
    function AnnualHomeCountChangePopUpWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.handleCountChangeReason = function (event) {
            _this.setState({ reason: event.target.value }, function () { return _this.validate(); });
            _this.props.onStateChange(_this.props.question.interactionField, event.target.value);
            _this.executeEvent("change");
        };
        _this.handleCountChangeReasonDescription = function (event) {
            _this.setState({ reasonInfo: event.target.value }, function () { return _this.validate(); });
            _this.props.onStateChange(_this.getSetting("reasonDescriptionField"), event.target.value);
            _this.executeEvent("change");
        };
        _this.saveChanges = function (event) {
            _this.validate(function () {
                if (_this.state.isSelectionValid) {
                    _this.setState({ popupOpen: false });
                    _this.props.onStateChange(_this.getSetting("uiStateField", ""), true);
                }
                else {
                    event.preventDefault;
                }
            });
        };
        _this.state = {
            popupOpen: true,
            reasonKeys: [],
            reason: "",
            reasonInfo: ""
        };
        _this.saveChanges = _this.saveChanges.bind(_this);
        _this.closePopup = _this.closePopup.bind(_this);
        return _this;
    }
    AnnualHomeCountChangePopUpWidget.prototype.componentDidMount = function () {
        var _this = this;
        var classifier = this.getSetting("classifier");
        if (classifier) {
            this.lookupService.fetchLookupValues(classifier, "en-UK").subscribe(function (lookupValues) {
                _this.setState({
                    reasonKeys: lookupValues.map(function (lookupValue) { return lookupValue.value; })
                });
            });
        }
    };
    AnnualHomeCountChangePopUpWidget.prototype.render = function () {
        var countWord = this.getSetting("countWord", "");
        return (React.createElement(reactstrap_1.Modal, { className: "my-2 info-modal", isOpen: this.state.popupOpen, toggle: this.closePopup, backdrop: "static" },
            React.createElement(reactstrap_1.ModalHeader, { toggle: this.closePopup },
                React.createElement("div", { className: "d-flex align-items-center" },
                    React.createElement("img", { src: "/img/Flow-info-selected.svg", className: "info-icon-selected", alt: "warning-sign" }),
                    React.createElement("span", { className: "text-blue-2 fs-22 font-weight-medium" },
                        "You have changed the number of ",
                        countWord))),
            React.createElement(reactstrap_1.ModalBody, { className: "overflow-visible" },
                React.createElement("div", { className: "mb-3" },
                    "Please tell us ",
                    React.createElement("b", null,
                        "why is the number of ",
                        countWord,
                        " changing?")),
                this.renderInputField()),
            React.createElement(reactstrap_1.ModalFooter, { className: "d-flex" },
                React.createElement("button", { type: "button", className: "btn btn-primary btn-add", onClick: this.saveChanges }, "Ok, I understand"))));
    };
    AnnualHomeCountChangePopUpWidget.prototype.renderInputField = function () {
        return this.renderChangeReasonsOptions(this.state.reasonKeys, this.props.question.interactionField);
    };
    AnnualHomeCountChangePopUpWidget.prototype.renderChangeReasonsOptions = function (keys, interactionField) {
        var _this = this;
        var interactionFieldValue = journey_services_1.ObjectManipulator.fetchFieldValue(interactionField, this.props.interaction);
        var reasonDescriptionField = journey_services_1.ObjectManipulator.fetchFieldValue(this.getSetting("reasonDescriptionField", undefined), this.props.interaction);
        var reasons = [];
        Array.from(keys).map(function (key) {
            var reasonValue = key;
            reasons.push(React.createElement(React.Fragment, null,
                React.createElement("div", { key: key, className: "custom-control w-100 falcon-custom-radio mt-2 mb-3 pl-0" },
                    React.createElement("input", { className: "custom-radiobutton cursor-pointer ".concat((0, commonFunctions_1.getValidationStyle)(_this.state.isSelectionValid)), type: "radio", name: "".concat(key, "_").concat(interactionField), id: "".concat(interactionField, "-option-").concat(key), value: reasonValue, onChange: function (e) { return _this.handleCountChangeReason(e); }, checked: reasonValue === interactionFieldValue }),
                    React.createElement("label", { id: "option-".concat(key, "-label"), className: "checkbox-label label-bg-transparent mb-0", htmlFor: "option-".concat(key) }, reasonValue))));
        });
        if (this.state.isSelectionValid === false) {
            reasons.push(React.createElement("div", { className: "text-danger fs-14 font-weight-medium mt-md-0" }, "Please select the reason"));
        }
        if (interactionFieldValue === "Other") {
            reasons.push(React.createElement("div", { className: "form-group pb-2 mb-0" },
                React.createElement("label", { className: "font-light", htmlFor: "changeReasonInfoLabel" }, "Please give us more details (optional)"),
                React.createElement("textarea", { className: "form-control description-textarea", id: "changeReasonInfo", maxLength: 300, value: reasonDescriptionField, onChange: function (e) { return _this.handleCountChangeReasonDescription(e); }, onClick: function (e) { return _this.handleCountChangeReasonDescription(e); } })));
        }
        return reasons;
    };
    AnnualHomeCountChangePopUpWidget.prototype.validate = function (callback) {
        this.setState({
            isSelectionValid: !!this.state.reason
        }, callback);
    };
    AnnualHomeCountChangePopUpWidget.prototype.closePopup = function () {
        this.setState({ popupOpen: false });
        var previousValueField = this.getSetting("uiStatePreviousCountField");
        if (previousValueField) {
            var previousValue = journey_services_1.ObjectManipulator.fetchFieldValue(previousValueField, this.props.interaction);
            this.props.onStateChange(this.getSetting("countField"), previousValue);
        }
        this.props.onStateChange(this.getSetting("uiStateField", ""), false);
    };
    __decorate([
        (0, core_1.lazyInject)(plugin_journey_1.Types.LookupService),
        __metadata("design:type", Object)
    ], AnnualHomeCountChangePopUpWidget.prototype, "lookupService", void 0);
    AnnualHomeCountChangePopUpWidget = __decorate([
        (0, journey_model_1.settings)([
            { name: "reasonDescriptionField", type: journey_model_1.TypeDescriptions.String },
            { name: "countWord", type: journey_model_1.TypeDescriptions.String },
            { name: "uiStateField", type: journey_model_1.TypeDescriptions.String },
            { name: "uiStatePreviousCountField", type: journey_model_1.TypeDescriptions.String }
        ]),
        __metadata("design:paramtypes", [Object])
    ], AnnualHomeCountChangePopUpWidget);
    return AnnualHomeCountChangePopUpWidget;
}(plugin_journey_1.QuestionWidgetBase));
//# sourceMappingURL=AnnualHomeCountChangePopUpWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/annual/home/mta/AnnualHomeCountChangePopUpWidget.js
// module id = 3709
// module chunks = 0